/**
 * @description 导出默认通用配置
 */
const setting = {
  //标题
  title: 'BlueTee管理后台',
  //开发环境端口号
  devPort: '9999',
  // 路由模式，可选值为 history 或 hash
  routerMode: 'hash',
  //不经过token校验的路由
  routesWhiteList: ['/login', '/previewEditor'],
  //是否AES加解密
  isAes: false,
  //用户模板接口
  userUrl: 'http://localhost:8886',
  //基础模板接口
  businessUrl: 'http://localhost:8887'
}
module.exports = setting
